import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { deliverables } from '../data/content';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full bg-navy-900 py-16 text-white sm:py-24" data-id="element-133" data-mp="1mo22e5uxyvgv">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-134" data-mp="1ho5y05ic120s">
        <div className="text-center" data-id="element-135" data-mp="tyv4n93ba9wo">
          <h2 id="oferta-titulo" className="font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-5xl" data-id="element-136" data-mp="tzwghfs5j0fg">
            Recupera tu movilidad hoy
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-sand-100/80" data-id="element-137" data-mp="13ylz5arvgowr">
            Por menos de lo que cuesta un copago médico o una caja de analgésicos que no funcionan.
            Obtén el Protocolo Completo de Alivio con un pago único.
          </p>
        </div>

        <div className="mt-10 rounded-2xl bg-white p-7 text-ink sm:p-10" data-id="element-138" data-mp="2acbicr5h4p03">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-139" data-mp="pkqpof5323ce">
            <div data-id="element-140" data-mp="uisgjm8r36yf">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ember-600" data-id="element-141" data-mp="ui8z06n0ikkx">
                Pago único
              </p>
              <p className="mt-2 font-display text-5xl font-black leading-none text-navy-900" data-id="element-142" data-mp="zgafqkwyu7t8">
                $19<span className="ml-2 align-top text-lg font-bold text-ink/50" data-id="element-143" data-mp="13hw0esfqrqdz">USD</span>
              </p>
            </div>
            <ul className="grid gap-2 text-sm text-ink/70 sm:text-right" data-id="element-144" data-mp="bsu0aiusu7jp">
              <li className="flex items-center gap-2 sm:justify-end" data-id="element-145" data-mp="bqpx634q5ckh">
                <DownloadIcon aria-hidden="true" className="h-4 w-4 text-ember-600" data-id="element-146" data-mp="ftm9jc3o8cfz" />
                Acceso instantáneo
              </li>
              <li className="flex items-center gap-2 sm:justify-end" data-id="element-147" data-mp="kmyxdk0j0f7o">
                <LockIcon aria-hidden="true" className="h-4 w-4 text-ember-600" data-id="element-148" data-mp="3k845w0xwduw8" />
                Pago seguro
              </li>
            </ul>
          </div>

          <ul className="mt-8 grid gap-3 border-t border-sand-200 pt-8 sm:grid-cols-2" data-id="element-149" data-mp="vf7b8aa8w48w">
            {deliverables.map(item => <li key={item.title} className="flex items-start gap-2 text-sm leading-relaxed text-ink/75" data-id="element-150" data-mp="qg4k7tr3nyjx">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ember-600" strokeWidth={3} data-id="element-151" data-mp="154qxlpx62g8i" />
                {item.title}
              </li>)}
          </ul>

          <div className="mt-9 text-center" data-id="element-152" data-mp="7il8gid9c1tt">
            <CtaButton className="w-full sm:w-auto" data-id="element-153" data-mp="7jmm8ulnr2f8">¡Sí, quiero aliviar mi dolor ahora!</CtaButton>
            <p className="mt-4 text-sm text-ink/60" data-id="element-154" data-mp="livwzer3h4bt">
              Haz clic para obtener acceso instantáneo y empezar tu primera sesión de descompresión.
            </p>
          </div>
        </div>
      </div>
    </section>;
}